export default (el) => {
  function loadImage() {
    const imageElement = el.nodeName === 'IMG'
      ? el
      : Array.from(el.children).find(
        el => el.nodeName === "IMG"
      );

    if (imageElement && !imageElement.classList.contains('loaded')) {
      imageElement.classList.add('opacity-0', 'transition-opacity', 'duration-700');

      imageElement.addEventListener("load", () => {
        setTimeout(() => {
          imageElement.classList.add("loaded");
          // imageElement.classList.add("fade-in");
          imageElement.classList.remove('opacity-0');
        }, 100);
      });

      imageElement.addEventListener("error", () => console.error("error"));

      if(imageElement.dataset.srcset) {
        imageElement.setAttribute('srcset', imageElement.dataset.srcset);
        imageElement.removeAttribute('data-srcset');
      }

      imageElement.setAttribute('src', imageElement.dataset.src);
      imageElement.removeAttribute('data-src');
    }
  }

  function handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadImage();
        observer.unobserve(el);
      }
    });
  }

  function createObserver() {
    const options = {
      root: null,
      threshold: "0"
    };

    const observer = new IntersectionObserver(handleIntersect, options);

    observer.observe(el);
  }

  if (window["IntersectionObserver"]) {
    createObserver();
  } else {
    loadImage();
  }
};
